export default __webpack_public_path__ + "static/media/Hyrkanian Fleet Scream-Catcher.c91d999b.jpg";